export default __webpack_public_path__ + "static/media/diners.84ffe7b9.svg";